/**
 *@法语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: 'Pas intéressé par cette vidéo? %second%',
  _switch_one: 'Une autre',
  _next_reward_text: 'Regardez une autre vidéo pour obtenir ',
  _next_reward_button: 'Regarde',
}